import React, {Fragment} from 'react';

import {Card, Stack} from '@mui/material';
import {MainFooter, MainHeader} from 'presentation/components';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {translations} from 'presentation/translations-new';
import {useHealthConfirmationBookingContent} from './hooks/useHealthConfirmationBookingContent';
import {HealthConfirmationBookingContentProps} from './types';
import {StyledContainer, StyledFooterBox} from './styles';
import {SuccessHeader} from 'presentation/modules/booking/shared/ui/components/ConfirmationBooking/SuccessHeader';
import {AppointmentInfoList} from 'presentation/modules/booking/shared/ui/components/ConfirmationBooking/AppointmentInfoList';
import {ActionButtons} from 'presentation/modules/booking/shared/ui/components/ConfirmationBooking/ActionButtons';
import {ConfirmationCTAButtons} from 'presentation/modules/booking/shared/ui/components/ConfirmationBooking/ConfirmationCTAButtons';
import {PrintTemplateNew} from 'presentation/modules/booking/shared/ui/components/PrintTemplateNew';
import {AppointmentAddress} from 'presentation/modules/booking/shared/ui/components/ConfirmationBooking/AppointmentAddress';
import {AppointmentDocumentAlert} from 'presentation/modules/booking/shared/ui/components/ConfirmationBooking/AppointmentDocumentAlert';

const {confirmationBooking} = translations['pt-br'].privateFlow.bookingFlow;

export function HealthConfirmationBookingContentNew({
	bookedAppointment,
	goToMyAppointments,
}: HealthConfirmationBookingContentProps) {
	const {
		isMobile,
		isPrinting,
		isSharing,
		printContent,
		printRef,
		calendarEvent,
		date,
		hour,
		providerName,
		specialtyName,
		protocolNumber,
		beneficiaryName,
		planName,
		goToHome,
		shareContent,
		handleOpenGoogleMaps,
		clinicName,
		addressForMaps,
		formattedAddress,
	} = useHealthConfirmationBookingContent(bookedAppointment);

	return (
		<Fragment>
			<MainHeader
				title={confirmationBooking}
				handleClose={goToHome}
				hideBackBtn
				variant="subRoute"
			/>

			<StyledContainer>
				<Card elevation={0} sx={{borderRadius: 2, p: 3}}>
					<Stack gap={3}>
						<SuccessHeader flowType={FlowEnum.HEALTH} />

						<AppointmentInfoList
							beneficiaryName={beneficiaryName}
							planName={planName}
							providerName={providerName}
							specialtyName={specialtyName}
							clinicName={clinicName}
							date={date}
							hour={hour}
							protocolNumber={protocolNumber}
							flowType={FlowEnum.HEALTH}
						/>

						<ActionButtons
							isMobile={isMobile}
							isPrinting={isPrinting}
							printContent={printContent}
							shareContent={shareContent}
							calendarEvent={calendarEvent}
							isSharing={isSharing}
						/>

						<AppointmentAddress
							addressForMaps={addressForMaps}
							formattedAddress={formattedAddress}
							handleOpenMap={handleOpenGoogleMaps}
						/>

						<AppointmentDocumentAlert />
					</Stack>
				</Card>

				<ConfirmationCTAButtons
					goToMyAppointments={goToMyAppointments}
					goToHome={goToHome}
					isMobile={isMobile}
				/>
			</StyledContainer>

			<StyledFooterBox>
				<MainFooter />
			</StyledFooterBox>

			<PrintTemplateNew
				bookedAppointment={bookedAppointment}
				flowType={FlowEnum.HEALTH}
				printRef={printRef}
			/>
		</Fragment>
	);
}
